import {
  BillableItemIds,
  BillableItemPaymentModel,
  BillableItemStatus,
  BillableItemType,
  CurrencyCode,
  FeatureType
} from '../../../enums/billableItem';
import { BillableItem, Feature } from '../../../interfaces/billableItem';

const basePlanFeatures: Feature[] = [
  { type: FeatureType.PictureMessaging, quantity: 1 },
  { type: FeatureType.PersonalisedLandingPage, quantity: 1 },
  { type: FeatureType.DynamicTemplate, quantity: 1 },
  { type: FeatureType.SubscriberGrowthTool, quantity: 1 },
  { type: FeatureType.TollFreeNumber, quantity: 1 },
  { type: FeatureType.CustomDomain, quantity: 1 },
  { type: FeatureType['10DlcA2P10DlcShortcode'], quantity: 1 },
  { type: FeatureType.BulkContactUpload, quantity: 1 },
  {
    type: FeatureType.BundledSmsCreditCost,
    quantity: 1,
    priceInCents: 1
  },
  {
    type: FeatureType.PayAsYouGoSmsCreditCost,
    quantity: 1,
    priceInCents: 2
  },
  { type: FeatureType.MmsTextOverlay, quantity: 1 }
];

export const monthlyPlans2021: BillableItem[] = [
  {
    id: BillableItemIds.Plan.StarterPlanUsdMonthly,
    name: 'Starter',
    type: BillableItemType.Plan,
    priceInCents: 4900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      ...basePlanFeatures,
      {
        type: FeatureType.Contact,
        quantity: 500
      },
      {
        type: FeatureType.BundledMmsCreditCost,
        quantity: 1,
        priceInCents: 3
      }
    ]
  },
  {
    id: BillableItemIds.Plan.GrowthPlanUsdMonthly,
    name: 'Growth plan',
    type: BillableItemType.Plan,
    priceInCents: 12500,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      ...basePlanFeatures,
      {
        type: FeatureType.Contact,
        quantity: 5000
      },
      {
        type: FeatureType.BundledMmsCreditCost,
        quantity: 1,
        priceInCents: 3
      }
    ]
  },
  {
    id: BillableItemIds.Plan.PremiumPlanUsdMonthly,
    name: 'Premium',
    type: BillableItemType.Plan,
    priceInCents: 33900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      ...basePlanFeatures,
      {
        type: FeatureType.Contact,
        quantity: 20000
      },
      {
        type: FeatureType.BundledMmsCreditCost,
        quantity: 1,
        priceInCents: 3
      },
      { type: FeatureType.ApiAutomationCampaign, quantity: 1 }
    ]
  }
];

export const yearlyPlans2021: (BillableItem | undefined)[] = monthlyPlans2021
  .map(plan => {
    switch (plan.id) {
      case BillableItemIds.Plan.StarterPlanUsdMonthly:
        return {
          ...plan,
          id: BillableItemIds.Plan.StarterPlanUsdYearly,
          paymentModel: BillableItemPaymentModel.Yearly,
          priceInCents: 46800
        };
      case BillableItemIds.Plan.GrowthPlanUsdMonthly:
        return {
          ...plan,
          id: BillableItemIds.Plan.GrowthPlanUsdYearly,
          paymentModel: BillableItemPaymentModel.Yearly,
          priceInCents: 118800
        };
      case BillableItemIds.Plan.PremiumPlanUsdMonthly:
        return {
          ...plan,
          id: BillableItemIds.Plan.PremiumPlanUsdYearly,
          paymentModel: BillableItemPaymentModel.Yearly,
          priceInCents: 322800
        };
      default:
        return;
    }
  })
  .filter(Boolean);
